import { render, staticRenderFns } from "./OcorrenciaView.vue?vue&type=template&id=d8132840&"
import script from "./OcorrenciaView.vue?vue&type=script&lang=js&"
export * from "./OcorrenciaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports